import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import { errorText } from '../../../helpers/login';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import useForm from '../../../helpers/useForm';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';

const LoginUserScreen = ({history}) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const [errorUser, setErrorUser] = useState(undefined);
  const [verifyingUser, setVerifyingUser] = useState(false);
  const app = useSelector((state) => state.app);

  const hasMarkets = app.markets.length > 1;

  function validate(values) {
    let errors = {};

    if (!values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    return errors;
  }
  const onContinueHandle = (email) => {
    history.push({
      pathname: '/login-password',
      search: '?email=' + email,
    });
  };
  const tenantId = useSelector((state) => state.app.tenantId);

  const sendForm = async () => {
    setVerifyingUser(true);
    setErrorUser(undefined);
    try {
      const result = await welletContext.apis.tickets.post(`users/Available`, {
        email: values.email,
        tenantId: tenantId,
      });

      if (!result.data.isAvailable) {
        errorText(result.data.availableMessage, setErrorUser, t);
      } else onContinueHandle(values.email);
    } catch (error) {
      console.error(error);
    }
    setVerifyingUser(false);
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);



  const onChangeEmail = (e) => {
    handleChange(e);
    setErrorUser(null);
  };

  const inputEmail = () => (
    <InputFormBorder
      name={'email'}
      type={'email'}
      value={values.email}
      placeholder='E-mail'
      label='E-mail'
      error={errors.email || errorUser}
      onChange={onChangeEmail}
      forceLowecase={true}
    />
  );

  return (
    <>
      <Header title={''}  hasBackground={true} />
      <ContentApp background={true}>
        <div className=''>
          <form onSubmit={handleSubmit}>
            <div className='font-medium bold' style={{ color: '#fff' }}>
              {t('enterEmail')}
            </div>
            <div className='mt-5'>{inputEmail()}</div>
            <div className='mt-5'>
              <Button
                size={'large'}
                text={
                  verifyingUser ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('continue')
                  )
                }
                className={`${verifyingUser ? 'loading' : ''} btn-primary`}
                hasBorder={true}
                icon={verifyingUser ? false : true}
                iconColor='#000'
                typeIcon='arrow'
              />
            </div>
          </form>
          <div
            className='text-center mt-5 text-primary'
            onClick={() => {
              history.push(hasMarkets ? `/market-selector` : '/sign-up-terms');
            }}
          >
            {t('login.signUp')}
          </div>
        </div>
      </ContentApp>
    </>
  );
};

export default LoginUserScreen;
